export default "__VITE_ASSET__Cl$jiRuh__"